interface SendGlyphProps {
  className?: string;
  size?: number;
}

/**
 * Paper-airplane icon. Shared between the leaf-sheet "Send a card"
 * row (default 22 px) and the Garden vine airplane (18 px). Stroke
 * cascade matches the other Lucide-style glyphs in LeafActionSheet
 * so all card icons read as the same family.
 */
export default function SendGlyph({ className, size = 22 }: SendGlyphProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );
}
